// extracted by mini-css-extract-plugin
export var container = "_hq-1";
export var cornerButtonContainer = "_hq-6";
export var disabled = "_hq-2";
export var dragActive = "_hq-3";
export var fileContainer = "_hq-5";
export var hiddenInput = "_hq-4";
export var widthContainer = "_hq-0";